module.exports = __webpack_public_path__ + "static/media/99.bb07630e.jpg";